import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {Text} from '../../../../../../shared/components/text';
import {dateFormats} from '../../../../../../shared/constants/date';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {hexToRgbA, datePipe} from '../../../../../../shared/pipes';
import {useTheme} from '../../../../../../shared/theme';
import {Props} from './model';
import {buildDocumentName, statusName, statusType} from '../../../../common/documents/model';
import {images} from '../../../../../../assets/icons';
import {LoadableContent} from '../../../../../../shared/components/loadableContent';
import Screen from '../../../../../../shared/components/screen';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';

export default ({documents, handlePressDocumentCard, handleRefresh}: Props) => {
  const _theme = useTheme();
  const styles = useStyles(({theme}) => ({
    container: {
      backgroundColor: theme.color.primaryNonGreyBackground,
      borderRadius: 14,
      width: '100%',
      marginBottom: 30,
    },
    header: {
      minHeight: 45,
      paddingHorizontal: 20,
      paddingVertical: 10,
      position: 'relative',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    body: {
      borderBottomLeftRadius: 14,
      borderBottomRightRadius: 14,
      backgroundColor: hexToRgbA(theme.applications.mobileListItemBodyBg, 0.15),
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 20,
      paddingVertical: 10,
    },
    status: {
      width: 10,
      height: 10,
      position: 'absolute',
      right: 8,
      top: 8,
    },
    textNormal: {
      ...theme.fonts.body,
    },
    textActive: {
      ...theme.fonts.action,
    },
    dateWrapper: {
      width: 128,
    },
    dateText: {
      ...theme.fonts.label,
      color: theme.color.labelText,
    },
    statusWrapper: {
      flexGrow: 1,
    },
    statusText: {
      ...theme.fonts.bodySmallLight,
      textAlign: 'right',
    },
  }));

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic' onRefresh={handleRefresh}>
        <View style={{marginHorizontal: 16, marginVertical: 16}}>
          <LoadableContent loading={!documents}>
            {documents.length > 0 ? (
              documents.map((document, i) => (
                <TouchableOpacity style={styles.container} key={i} onPress={() => handlePressDocumentCard(document)}>
                  <View style={styles.header}>
                    <View style={{flex: 50}}>
                      <Text style={styles.textNormal}>{buildDocumentName(document)}</Text>
                    </View>
                    <View style={{flex: 1}}>
                      <images.Download2 width={24} height={24} color={'grey'} strokeWidth={0.2} />
                    </View>
                  </View>
                  <View style={styles.body}>
                    <View style={styles.dateWrapper}>
                      <Text style={styles.dateText}>{datePipe(document.updatedAt, dateFormats.shortDate)}</Text>
                    </View>
                    <View style={styles.statusWrapper}>
                      <Text
                        style={[
                          styles.statusText,
                          {
                            color: _theme.applications.statusColors[statusType(document)],
                          },
                        ]}>
                        {statusName(document)}
                      </Text>
                    </View>
                  </View>
                </TouchableOpacity>
              ))
            ) : (
              <Text type='h5' style={{alignSelf: 'center'}}>
                Документы отсутствуют
              </Text>
            )}
          </LoadableContent>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
